import * as Sentry from '@sentry/react';
import React from 'react';
import { ErrorBoundaryOrtk, ErrorBoundaryProps } from '@oneview/shared/ErrorBoundaryOrtk';

export const ErrorBoundary: React.FunctionComponent<ErrorBoundaryProps> = (props) => {
    return (
        <ErrorBoundaryOrtk
            {...props}
            onCatch={(error, errorInfo) => {
                const errorId = Sentry.captureException(error);
                Sentry.setExtra('error.info', errorInfo);
                return errorId;
            }}
        />
    );
};
